export default __webpack_public_path__ + "static/media/idd2.12c9156f.png";